// extracted by mini-css-extract-plugin
export default {"list":"styles_list__G2utA","listBorders":"styles_listBorders__P5NJh","listItem":"styles_listItem__VRw05"};